import React, { Fragment } from 'react';
import { EventProductDetailReportV2 } from '@/model/EventProductDetailReportV2';
import { Card } from 'reactstrap';
import { CustomTable } from '@/components/Table';
import { toCurrency } from '@/helpers/masks/toCurrency';

interface StateProps {
  products: EventProductDetailReportV2[];
}

export const SaleProductProductsContent: React.FC<StateProps> = ({ products }) => (
  <Fragment>
    <h6 className="mb-4 collapseTableText">Vendas geral por produto</h6>
    <hr />
    <Card
      className="mb-5 card-no-border customTableScroll"
      style={{ border: 'none', overflow: 'auto' }}
    >
      {products && products.length > 0 && (
        <div className="p-4">
          <CustomTable
            theme="secondary"
            numberRowsPerPage={0}
            progressPending={false}
            columns={[
              {
                name: 'Produto/Combo',
                selector: row => row.productName,
              },
              {
                name: 'Vendidos',
                selector: row => row.productSold,
              },
              {
                name: 'Estoque inicial',
                selector: row => row.initialInventory,
              },
              {
                name: 'Estoque disponível',
                selector: row => row.availableStock,
              },
              {
                name: 'Valor',
                selector: row => row.productValue,
              },
              {
                name: 'Venda',
                selector: row => row.totalSaleVale,
              },
              {
                name: 'Comissão',
                selector: row => row.totalCommission,
              },
              {
                name: 'Venda + comissão',
                selector: row => row.totalSaleValueWithCommission,
              },
            ]}
            data={products.map(data => ({
              productName: data.productName,
              productSold: data.productsSold,
              initialInventory: data.initialInventory,
              availableStock: data.availableStock,
              productValue: toCurrency(data.productValue),
              totalSaleVale: toCurrency(data.totalSaleVale),
              totalCommission: toCurrency(data.totalCommission),
              totalSaleValueWithCommission: toCurrency(data.totalSaleValueWithCommission),
            }))}
          />
        </div>
      )}
    </Card>
  </Fragment>
);
